<div class="progressbar-circle" data-animate="false">
    <div class="circle {{ hoverClass }}" data-percent="50">
        <div>{{ percentage }}%</div>
        <p class="mt-3 mb-0 font-c iq-fw-6 text-black">{{ title }}</p>
    </div>
</div>